import { GeneExpression, isChanceGene } from "../../types/Gene.ts"
import { Morph } from "../../types/Morph.ts"

export const FindMorphByGenes = (genes: {
    gene_name: string,
    expression: GeneExpression
}[], morphs: Morph[]) => {
    // find the morph that has the same genes as the input
    const visibleGenes = genes.filter((gene) => !isChanceGene(gene) && gene.expression !== 'HET');
    let morph: Morph | undefined = morphs.find((morph) => {
        if (morph.genes.length !== visibleGenes.length) return false;
        let match = true;
        visibleGenes.forEach((gene) => {
            if (!morph.genes.find((morphGene) => morphGene.gene_name === gene.gene_name && morphGene.expression === gene.expression)) {
                match = false;
            }
        });
        return match;
    });
    return morph;
}